<template>
    <v-card
    elevation="0"
    v-bind:href="resource.url"
    class="mx-auto  resource-card-container"
    v-bind:min-width="minWidth"
    target="_blank"
>

      <div class="resource-card-text-container">
        <v-img
        class="resource-card-image"
        v-bind:src="resource.image"
        height="200px">
        </v-img>
        <v-card-title primary-title class="pt-3">
          <div>
            <h3 class="resource-card-title">{{resource.title}}</h3>
            <p class="resource-card-text">{{resource.content}}</p>
          </div>
        </v-card-title>
      </div>
      <v-card-actions class="resource-card-link-container">
        <div>
          <p class="resource-card-link-text">{{resource.linkName}}</p>
          <img class="resource-card-link-img" src="@/assets/link.svg"/>
        </div>
      </v-card-actions>
    </v-card>
</template>

<style lang="scss">

  .resource-card-container {
    position:relative;
    flex:1;
    background: #ffffff;
    border: 1px solid #e2e2e2 !important;
    border-radius: 5px !important;
    box-sizing: border-box;
    text-align:left;
    overflow-x: visible;
    white-space: normal;
  }

  .resource-card-text-container{
    padding-bottom:23px;
  }

  .resource-card-title {
    font-weight:800;
    font-size: 18px;
    line-height:125%;
    color:#333333;
  }
  .resource-card-image {
    border-radius: 5px 5px 0px 0px;
    object-fit:cover;
  }

  .resource-card-text {
    font-weight:500;
    font-size: 16px;
    line-height:22px;
    color:#333333;
  }

  .resource-card-link-text {
    font-weight: 500;
    font-size: 16px;
    line-height:22px;
    color: #aaaaaa;
    display:inline;

  }

  .resource-card-link-img {
    vertical-align: middle;
    padding-bottom: 4px;
    margin-left: 15px;

  }

  .resource-card-link-container {
    position:absolute;
    margin-left: 8px;
    bottom:0;
  }

</style>

<script>
export default {
  name: 'resourceCard',
  props: {
    minWidth: Number,
    resource: {
      image: String,
      title: String,
      content: String,
      linkName: String,
      url: String
    }
  }
}
</script>
